import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';
import ListCatalog from './ListCatalog';

//Create Catalog dependencies
import MyTooltip from '../common/MyTooltip';
import CreateCatalogModel from './CreateCatalogModel';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_ADMIN
} from '../common/redux/constantes';


export class DefaultPage extends Component {

  state = {
    openCreateCatalogDialog:false,
    createCatalogDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    catalogEdit:{}
  }


  static propTypes = 
  {
    dc: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateCatalogDialog = ()=>
  {
    this.setState({openCreateCatalogDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateCatalogDialog = ()=>{
    this.setState({
      openCreateCatalogDialog:true, 
      createCatalogDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      catalogEdit:{}
    });
  }

  editCatalog = (catalog)=>{
     this.setState({
      openCreateCatalogDialog:true, 
      createCatalogDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      catalogEdit:catalog
    });
  }

  showCatalog = (catalog)=>{
     this.setState({
      openCreateCatalogDialog:true, 
      createCatalogDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      catalogEdit:catalog
    });
  }

  render() {
    return (
      <div >
          <MySideBar>
            <ListCatalog ref={instance => { this.list = instance; }} editCatalog={this.editCatalog} showCatalog={this.showCatalog}/>
            <CreateCatalogModel 
              openDialog={this.state.openCreateCatalogDialog} 
              closeDialog={this.closeCreateCatalogDialog} 
              actionDialog={this.state.createCatalogDialogAction}
              catalogEdit={this.state.catalogEdit}
            />
            {
              Number(localStorage.getItem("role")) === ROLE_ADMIN?
              (<MyTooltip openDialog={this.openCreateCatalogDialog} />)
              :null
            }
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    dc: state.dc,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/dc/DefaultPage.js